/**
 * Created by xiaomo on 2021/11/25.
 */

export function tripartite( num ) {
    var type = true;
    var value = '';
    //去除逗号字符
    num = ( num + '' ).replace( /,/g, "" );
    //判断是否有小数点
    if ( num.indexOf( "." ) < 0 ) {
        var t1 = num.toString().split( '' );

    } else {
        type = false;
        var arr = num.toString().split( '.' );
        var t1 = arr[ 0 ].toString().split( '' );
        var t2 = arr[ 1 ].toString();
    }

    //添加逗号字符
    var result = [],
        counter = 0;
    for ( var i = t1.length - 1; i >= 0; i-- ) {
        counter++;
        result.unshift( t1[ i ] );
        if ( ( counter % 3 ) == 0 && i != 0 ) {
            result.unshift( ',' );
        }
    }

    //判断显示类型是否有小数
    if ( type === true ) {
        value = result.join( '' );
    } else {
        value = result.join( '' ) + '.' + t2;
    }
    return value;
}

/**
 * 将字符串后加空格，以保证字符串字节长度===length
 * @param {String} value 要修正的字符串
 * @param {Number} length 修正为多少个字节
 * @param {Number} byteSize 修正字节需要几个空格（因为用于echarts，所以默认设置为2个）
 * @returns {String} 修正后的字符串
 */
export function textLength( value, length, byteSize = 2 ) {
    let nowLength = new Blob( [ value ] ).size
    let l = length - nowLength
    if ( l <= 0 ) return value
    var byte = ``
    while ( byteSize-- ) byte += ` `
    while ( l-- ) value += byte
    return value
}


export function dateFormat( timestamp, formats ) {
    // formats格式包括
    // 1. Y-m-d
    // 2. Y-m-d H:i:s
    // 3. Y年m月d日
    // 4. Y年m月d日 H时i分
    formats = formats || 'Y-m-d';

    var zero = function ( value ) {
        if ( value < 10 ) {
            return '0' + value;
        }
        return value;
    };

    var myDate = timestamp ? new Date( timestamp ) : new Date();

    var year = myDate.getFullYear();
    var month = zero( myDate.getMonth() + 1 );
    var day = zero( myDate.getDate() );

    var hour = zero( myDate.getHours() );
    var minite = zero( myDate.getMinutes() );
    var second = zero( myDate.getSeconds() );

    return formats.replace( /Y|m|d|H|i|s/ig, function ( matches ) {
        return ( {
            Y: year,
            m: month,
            d: day,
            H: hour,
            i: minite,
            s: second
        } )[ matches ];
    } );
}

export function isArray( arg ) {
    return Object.prototype.toString.call( arg ) === '[object Array]'
}

export function dataArrFormat( arr ) {
    let obj = {};
    // 将数组转化为对象
    for ( let key in arr ) {
        obj[ key ] = arr[ key ];
    };
    let newObj = Object.keys( obj ).map( val => ( {
        label: obj[ val ],
        value: obj[ val ]
    } ) );
    return newObj
}

export function isEmpty( obj ) {
    if ( typeof obj == "undefined" || obj == null || obj == "" ) {
        return true;
    } else {
        return false;
    }
}


export function scaleSize( size ) {
    let screenWidth = this.screenWidth;
    if ( screenWidth > 540 ) {
        screenWidth = 540;
    }
    return screenWidth * size / 375;
}

export function getMapValue( key ) {
    let value = this.map[ key ];
    if ( !value ) {
        return ''
    } else {
        return value;
    }
}

export function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace( /[xy]/g, function ( c ) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : ( r & 0x3 | 0x8 );
        return v.toString( 16 );
    } );
}

export function getUrlParams() {
    var url = window.location.href
    var params = {}
    if ( url.indexOf( '?' ) != -1 ) {
        var urls = url.split( '?' )
        var arr = urls[ 1 ].split( '&' )
        for ( var i = 0, l = arr.length; i < l; i++ ) {
            var a = arr[ i ].split( '=' )
            params[ a[ 0 ] ] = decodeURIComponent( a[ 1 ] )
        }
    }
    return params
}

export function getYMD( time ) {
    let t = new Date( time )
    let y = t.getFullYear();
    let m = ( t.getMonth() + 1 ) < 10 ? '0' + ( t.getMonth() + 1 ) : ( t.getMonth() + 1 )
    let d = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
    let hh = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
    let mm = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
    let ss = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
    return ( y + '-' + m + '-' + d + ' ' + hh + ':' + mm + ':' + ss )
}

export function getYMDString( time ) {
    let t = new Date( time )
    let y = t.getFullYear();
    let m = ( t.getMonth() + 1 ) < 10 ? '0' + ( t.getMonth() + 1 ) : ( t.getMonth() + 1 )
    let d = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
    return y + '-' + m + '-' + d
}

export function getYMDSimple( time ) {
    let t = new Date( time )
    let y = t.getFullYear();
    let m = ( t.getMonth() + 1 ) < 10 ? '0' + ( t.getMonth() + 1 ) : ( t.getMonth() + 1 )
    let d = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
    return y + '-' + m + '-' + d
}

export function getYMString( time ) {
    let t = new Date( time )
    let y = t.getFullYear();
    let m = ( t.getMonth() + 1 ) < 10 ? '0' + ( t.getMonth() + 1 ) : ( t.getMonth() + 1 )
    return y + '-' + m
}

export function getYM() {
    let t = new Date()
    let y = t.getFullYear();
    let m = ( t.getMonth() + 1 ) < 10 ? '0' + ( t.getMonth() + 1 ) : ( t.getMonth() + 1 )
    return y + '年' + m + '月'
}

export function getCurrentYMD() {
    let t = new Date()
    let y = t.getFullYear();
    let m = ( t.getMonth() + 1 ) < 10 ? '0' + ( t.getMonth() + 1 ) : ( t.getMonth() + 1 )
    let d = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
    return y + '-' + m + '-' + d
}

export function getDaysBetween( dateString1, dateString2 ) {
    var startDate = Date.parse( dateString1 );
    var endDate = Date.parse( dateString2 );
    if ( startDate > endDate ) {
        return 0;
    }
    if ( startDate == endDate ) {
        return 1;
    }
    var days = ( endDate - startDate ) / ( 1 * 24 * 60 * 60 * 1000 ) + 1;
    return days;
}

//加密
export function encrypt( word, keyStr ) {
    keyStr = keyStr ? keyStr : 'blD9rP7jLvA2qjrD';
    var key = CryptoJS.enc.Utf8.parse( keyStr ); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
    var srcs = CryptoJS.enc.Utf8.parse( word );
    var encrypted = CryptoJS.AES.encrypt( srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    } );
    return encrypted.toString();
}


//解密
export function decrypt( word, keyStr ) {
    keyStr = keyStr ? keyStr : 'blD9rP7jLvA2qjrD';
    var key = CryptoJS.enc.Utf8.parse( keyStr ); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
    var decrypt = CryptoJS.AES.decrypt( word, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    } );
    return CryptoJS.enc.Utf8.stringify( decrypt ).toString();
}

/**
 * @description: 是否为移动端
 */
export function isMoblie() {
    let mobile = navigator.userAgent.match( /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i )
    return mobile != null
}